import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SvgInstagam from "../../../assets/svg/SvgInstagan";
import SvgFacebook from "../../../assets/svg/SvgFacebook";
import SvgTictok from "../../../assets/svg/SvgTictok";
import SvgYoutube from "../../../assets/svg/SvgYoutube";
import styles from "./Footer.module.css";
import { useSelector } from "react-redux";

export const Footer = () => {
  const [socialNetworks, setSocialNetworks] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const { userType } = useSelector((state) => state.auth);

  // Función para obtener las redes sociales desde la API
  const fetchSocialNetworks = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/social-logo`);
      if (response.ok) {
        const data = await response.json();
        // Filtrar solo las redes sociales que estén publicadas
        const publishedNetworks = data.filter(network => network.estado === "Publicado");
        setSocialNetworks(publishedNetworks);
      } else {
        console.error('Error al obtener redes sociales:', response.status);
      }
    } catch (error) {
      console.error('Error al obtener redes sociales:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSocialNetworks();
  }, []);

  // Función para renderizar el ícono SVG según el nombre de la red social
  const renderSocialIcon = (networkName) => {
    switch (networkName.toLowerCase()) {
      case 'instagram':
        return <SvgInstagam />;
      case 'facebook':
        return <SvgFacebook />;
      case 'tiktok':
        return <SvgTictok />;
      case 'youtube':
        return <SvgYoutube />;
      default:
        return null;
    }
  };

  const hiddenFooterRoutes = ["/images/encabezado",
    "/images/whatsapp",
    "/images/encabezado",
    "/images/facebook",
    "/images/instagram",]; // Especifica las rutas a excluir
  const location = useLocation();
  // Si la ruta actual está en hiddenFooterRoutes, no muestra el footer
  if (hiddenFooterRoutes.includes(location.pathname)) {
    return null;
  }
  // console.log(location);

  return (
    <div className={styles.contenedor}>
      <div className={styles.logo}>
        <Link to={"/"} onClick={handleScrollToTop}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="182"
            height="110"
            viewBox="0 0 182 110"
            fill="none"
          >
            <g clipPath="url(#clip0_65_314)">
              <path
                d="M176.63 40.37C176.49 40.49 176.43 40.69 176.34 40.87C176.17 41.19 176 41.52 175.83 41.84C174.67 43.99 173.38 46.09 171.85 48C170.75 49.37 169.53 50.67 168.12 51.72C167.09 52.48 165.95 53.12 164.72 53.49C163.76 53.78 162.75 53.9 161.75 53.82C160.9 53.75 160.07 53.54 159.29 53.2C158.63 52.92 158.01 52.56 157.44 52.14C157.03 51.84 156.63 51.5 156.28 51.14C156.23 51.09 155.88 50.79 155.9 50.7C160.84 50.55 172.99 28.47 166.01 21.64C164.17 19.84 160.49 19.66 160.09 19.65C154.18 19.52 149.97 24.42 149.45 25.04C143.76 31.86 143.19 44.69 142.98 49.43C142.98 49.63 142.92 50.93 142.24 52.39C142.04 52.82 140.78 55.55 138.91 55.53C138.01 55.53 137.34 54.88 137.15 54.7C135.5 53.07 135.94 50.14 136.5 47.03C137.71 40.35 139.19 34.63 139.92 31.6C140.63 28.65 141.11 26.24 141.4 24.76C140.54 24.76 138.82 24.89 136.97 25.87C135.04 26.88 133.94 28.29 133.46 29.01C133.11 30.37 132.56 32.56 131.91 35.28C130.5 41.22 129.94 44.36 128.28 48.6C126.22 53.89 124.96 55.02 123.66 55.44C122.58 55.78 120.81 55.87 119.59 54.89C117.6 53.28 118.17 49.65 120.14 38.81C120.59 36.33 121.22 32.92 121.99 28.83C121.65 28.11 120.89 26.79 119.4 25.69C117.43 24.23 115.39 24.05 114.6 24.03C114 26.92 113.62 29.27 113.4 30.78C111.53 41.4 110.15 49.19 110.07 49.44C110.01 49.65 109.89 49.81 109.89 49.81C109.83 49.89 109.77 49.95 109.73 49.97C109.72 49.98 109.71 49.99 109.7 49.99C109.5 50.15 102.91 55.98 101.94 57.01C101.88 57.08 101.84 57.12 101.76 57.19C101.42 57.52 101.12 57.81 101.02 57.74C100.94 57.69 101 57.45 101.02 57.37C101.07 57.19 101.12 57.01 101.17 56.83C101.88 54.44 102.62 52.06 103.36 49.68C103.74 48.44 104.13 47.2 104.51 45.96C104.66 45.46 104.97 44.82 104.87 44.28C104.83 44.06 104.71 43.86 104.58 43.68C104.32 43.31 103.97 43.01 103.6 42.76C103.23 42.51 102.51 42.18 102.07 42.18C101.7 42.18 101.7 42.43 101.54 42.75C101.28 43.28 101.01 43.8 100.74 44.33C96.57 52.45 94.32 56.71 91.51 56.74C90.22 56.75 89.26 55.87 89.09 55.71C85.5 52.33 90.16 41.86 93.98 36.56C98.41 30.39 101.31 30.87 102.3 30.87C103.29 30.87 104.79 32.2 104.79 34.22C104.79 36.24 102.34 36.56 102.34 37.7C102.34 37.77 102.04 40.54 105.82 40.54C109.6 40.54 110.98 34.14 110.98 34.14C110.98 34.14 113.37 21.65 101.1 21.65C88.83 21.65 79.55 40.6 78.37 52.09C77.06 64.87 87.38 62.39 87.96 65.68C88.13 66.62 87.16 67.19 87.16 67.19C87.16 67.19 72.19 74.89 67.19 93.34C62.19 111.79 77.71 109.67 77.71 109.67C84.24 108.23 88.12 105.05 89.86 103.38C96.62 96.92 97.54 88.18 97.97 84.06C97.97 84.06 98.36 79.97 97.79 73.16C97.7 72.05 97.42 70.17 97.26 69.51C97.23 69.4 97.33 69.8 97.15 69C96.97 68.22 96.94 68.08 96.97 67.89C97.01 67.58 97.17 67.36 97.34 67.15C98.38 65.9 100.67 64.19 100.67 64.19C100.86 64.05 101.58 63.36 103.03 61.98C103.87 61.19 104.7 60.39 105.52 59.58C106.07 59.05 106.61 58.51 107.16 57.97C107.46 57.67 107.77 57.37 108.07 57.06C108.26 56.88 108.43 56.68 108.61 56.49C108.71 56.39 108.79 56.27 108.91 56.2C109.23 56.01 109.26 56.63 109.32 56.8C109.53 57.36 109.8 57.91 110.08 58.44C110.67 59.55 111.4 60.58 112.27 61.49C113.16 62.41 114.19 63.2 115.35 63.76C116.58 64.36 117.93 64.7 119.3 64.77C119.48 64.77 119.66 64.78 119.83 64.78C125.57 64.78 129.84 57.89 129.76 57.86C130.48 60.17 132.54 61.66 136.9 61.95C141.26 62.24 145.52 57.52 146.33 57.52C147.34 57.52 149.17 58.67 149.17 58.67C153.9 62.3 159.91 62.52 159.91 62.52C161.08 62.66 162.27 62.68 163.45 62.56C165 62.39 166.52 61.97 167.94 61.32C169.36 60.67 170.56 59.87 171.71 58.91C172.85 57.96 173.87 56.88 174.8 55.72C175.7 54.59 176.52 53.4 177.26 52.16C177.94 51.01 178.56 49.83 179.12 48.62C179.59 47.6 180.03 46.56 180.42 45.51C180.7 44.75 180.97 43.99 181.21 43.22C181.31 42.89 181.6 42.35 181.44 42C181.29 41.65 180.86 41.39 180.56 41.19C180.43 41.1 180.3 41.01 180.17 40.93C179.91 40.78 179.64 40.64 179.36 40.54C178.78 40.32 178.08 40.23 177.47 40.2C177.24 40.19 176.98 40.17 176.76 40.25C176.7 40.27 176.65 40.3 176.61 40.34L176.63 40.37ZM85.51 91.38C84 92.91 82.87 93.05 82.34 93.05C82.07 93.05 81.24 93.05 80.52 92.49C79.61 91.78 79.47 90.6 79.41 90.09C78.74 84.46 89.17 75.62 89.57 75.49C89.68 75.46 89.75 75.49 89.75 75.49C89.75 75.49 89.89 75.55 89.93 75.86C90.53 79.97 88.64 85.28 88.64 85.28C87.25 89.16 86.49 90.37 85.5 91.38H85.51ZM158.1 30.92C158.31 30.88 158.89 30.77 159.4 31.07C160.23 31.57 160.31 32.83 160.34 33.35C160.65 38.37 154.22 42.11 153.87 42.22C153.65 42.29 153.5 42.22 153.5 42.22C153.5 42.22 153.39 42.17 153.32 42.04C153.08 41.61 154.54 31.6 158.1 30.92ZM79.97 36.53C79.97 36.53 80.67 26.7 73.5 25.93C73.5 25.93 70.11 25.35 64.95 27.74C63.61 27.24 62.38 26.79 61.13 26.34C60.47 26.1 59.58 25.77 58.73 26.16C58.48 26.27 58.29 26.42 58.18 26.53C57.03 29.2 55.63 32.06 53.93 35.03C53.06 36.55 52.18 37.98 51.29 39.32C51.19 39.49 50.59 40.54 51.03 41.7C51.31 42.43 52.07 43.16 53.84 43.61C53.77 43.46 50.38 47.73 49.47 50.08C48.56 52.43 46.14 66.14 56.92 66.14C67.7 66.14 78.19 49.49 79.98 36.54L79.97 36.53ZM59.64 56.82C58.83 56.14 58.75 55.06 58.72 54.42C58.65 53.25 58.91 52.13 60.22 49.33C60.98 47.72 61.63 46.54 61.86 46.1C63.87 42.4 65.14 40.43 66.66 38.56C67.83 37.12 68.79 36.17 70.18 35.93C70.54 35.87 71.4 35.73 72.2 36.22C73.36 36.93 73.48 38.41 73.51 38.71C73.59 39.68 73.27 40.44 73.14 40.74C70.49 46.83 65.93 53.12 65.93 53.12C64.21 55.51 62.77 57.46 61.13 57.37C60.25 57.32 59.65 56.82 59.65 56.82H59.64ZM47.66 12.39C47.37 12.39 40.28 11.19 36.8 21.66C36.01 24.04 39.32 29.98 40.63 29.98C42.42 29.98 41.92 20.08 46.48 20.08C51.04 20.08 48.12 26.52 48.12 26.52C48.12 26.52 35.53 63.8 19.35 63.8C11.41 63.8 15.87 54.4 16.94 51.99C18.02 49.59 32.53 23.43 32.53 15.78C32.53 8.12997 28.44 0.0999671 19.36 -3.2865e-05C10.28 -0.100033 0 10.54 0 19.75C0 28.96 5.89 28.76 6.97 28.76C8.05 28.76 11.72 28.95 16.57 20.24C16.57 20.24 9.87 24.28 8.34 22.36C6.81 20.44 13.9 6.13997 19.93 6.13997C20.35 6.13997 21.4 6.15997 22.29 6.83997C25.07 8.95997 23.33 15.2 23.06 16.18C22.55 18 21.86 19.45 19.36 23.39C15.27 29.84 13.47 31.74 10.12 37.25C8.41 40.06 7.54 41.51 6.61 43.72C5.39 46.61 4 49.92 4.02 54.07C4.03 55.71 4.07 61.71 8.41 66.17C13.81 71.71 21.88 70.71 23.16 70.59C32.05 69.74 41.25 56.24 42.32 54.51C43.39 52.79 53.64 32.92 53.64 18.99C53.64 12.8 47.94 12.41 47.65 12.41L47.66 12.39Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_65_314">
                <rect width="181.51" height="109.77" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Link>
      </div>
      <div className={styles.FooterSections}>
        Vogue
        <div className="footer-ayuda">
          <Link to={"/quienes-somos"} onClick={handleScrollToTop}>
            Quiénes somos
          </Link>
          <div className="redesss">
            {!loading && socialNetworks.map((network) => (
              <Link
                key={network._id}
                className={network.name === 'instagram' ? 'estilos' : network.name === 'youtube' ? 'ultimo' : ''}
                to={network.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {renderSocialIcon(network.name)}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.FooterSections}>
        Ayuda
        <div className="footer-ayuda">
          <Link to={"/contactanos"} onClick={handleScrollToTop}>
            Contáctanos
          </Link>

          {
            userType === "DIS" ? (
              <Link to={"/preguntasFrencuentesDistribuidora"} onClick={handleScrollToTop}>
                Preguntas frecuentes
              </Link>
            ) : (

              <Link to={"/preguntasFrencuentes"} onClick={handleScrollToTop}>
                Preguntas frecuentes
              </Link>
            )
          }


        </div>
      </div>
      <div className={styles.FooterSections}>
        Únete
        <div className="footer-ayuda">
          {
            userType !== 'DIS' &&
            <Link to={"/distribuidora"} onClick={handleScrollToTop}>
              Conviértete en distribuidor(a)
            </Link>
          }
          <Link to={"https://issuu.com/vogueelsalvador"} target="_blank">
            Ver catálogo
          </Link>
        </div>
      </div>
    </div>
  );
};